import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	learnMore: {
		id: 'software-deployment-frequency-report.common.learn-more',
		defaultMessage: 'Learn more',
		description: 'Learn more link to lead the user to the detail documentation',
	},
	development: {
		id: 'software-deployment-frequency-report.common.development',
		defaultMessage: 'Development',
		description: 'Deployment environment label - development environment',
	},
	testing: {
		id: 'software-deployment-frequency-report.common.testing',
		defaultMessage: 'Testing',
		description: 'Deployment environment label - testing environment',
	},
	staging: {
		id: 'software-deployment-frequency-report.common.staging',
		defaultMessage: 'Staging',
		description: 'Deployment environment label - staging environment',
	},
	production: {
		id: 'software-deployment-frequency-report.common.production',
		defaultMessage: 'Production',
		description: 'Deployment environment label - production environment',
	},
	unmapped: {
		id: 'software-deployment-frequency-report.common.unmapped',
		defaultMessage: 'Unmapped',
		description: 'Deployment environment label - unmapped environment',
	},
});
